import { Icon as e } from "../icon/index.js";
import { cn as t } from "../cn.js";
import { buttonBase as n, getVariantStyles as r, iconOnlySizeStyles as i, iconSizeMap as a } from "./style.js";
import * as o from "react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
// src/design/button/index.tsx
var l = o.createContext(null), u = () => {
	let e = o.useContext(l);
	if (!e) throw Error("Button compound components must be used within Button.Root");
	return e;
}, d = o.forwardRef((e, i) => {
	let { children: a, className: o, variant: c = "solid", size: u = "sm", colorScheme: d = "default", loading: f = !1, disabled: p = !1, fullWidth: m = !1, type: h = "button", ...g } = e, _ = p || f, v = {
		variant: c,
		size: u,
		colorScheme: d,
		loading: f,
		disabled: _
	};
	return /* @__PURE__ */ s(l.Provider, {
		value: v,
		children: /* @__PURE__ */ s("button", {
			ref: i,
			type: h,
			disabled: _,
			className: t(n({
				size: u,
				fullWidth: !!m,
				loading: !!f
			}), r(c, d), o),
			...g,
			children: a
		})
	});
});
d.displayName = "Button.Root";
var f = o.forwardRef((n, r) => {
	let { children: i, className: o, name: c, ...l } = n, d = u(), f = a[d.size];
	return /* @__PURE__ */ s("span", {
		ref: r,
		className: t("inline-flex items-center justify-center shrink-0", d.loading && "opacity-0", o),
		...l,
		children: c ? /* @__PURE__ */ s(e, {
			name: c,
			size: f,
			color: "inherit"
		}) : i
	});
});
f.displayName = "Button.Icon";
var p = o.forwardRef((e, n) => {
	let { children: r, className: i, ...a } = e, o = u();
	return /* @__PURE__ */ s("span", {
		ref: n,
		className: t("inline-flex items-center justify-center", o.loading && "opacity-0", i),
		...a,
		children: r
	});
});
p.displayName = "Button.Text";
var m = o.forwardRef((n, r) => {
	let { className: i, ...o } = n, c = u(), l = a[c.size];
	return c.loading ? /* @__PURE__ */ s("span", {
		ref: r,
		className: t("absolute inset-0 inline-flex items-center justify-center", i),
		...o,
		children: /* @__PURE__ */ s(e, {
			name: "Loader2",
			size: l,
			color: "inherit",
			className: "animate-spin"
		})
	}) : null;
});
m.displayName = "Button.Loader";
var h = o.forwardRef((n, r) => {
	let { children: i, variant: o = "solid", size: l = "sm", colorScheme: u = "default", loading: f = !1, disabled: h = !1, leftIcon: g, rightIcon: _, fullWidth: v = !1, loadingText: y, ...b } = n, x = a[l], S = (n) => typeof n == "string" ? /* @__PURE__ */ s("span", {
		className: t("inline-flex items-center justify-center shrink-0", f && "opacity-0"),
		children: /* @__PURE__ */ s(e, {
			name: n,
			size: x,
			color: "inherit"
		})
	}) : /* @__PURE__ */ s("span", {
		className: t("inline-flex items-center justify-center shrink-0", f && "opacity-0"),
		children: n
	}), C = !f && g, w = !f && _;
	return f && y ? /* @__PURE__ */ c(d, {
		ref: r,
		variant: o,
		size: l,
		colorScheme: u,
		loading: f,
		disabled: h,
		fullWidth: v,
		...b,
		children: [/* @__PURE__ */ s(e, {
			name: "Loader2",
			size: x,
			color: "inherit",
			className: "animate-spin"
		}), /* @__PURE__ */ s("span", {
			className: "inline-flex items-center justify-center",
			children: y
		})]
	}) : /* @__PURE__ */ c(d, {
		ref: r,
		variant: o,
		size: l,
		colorScheme: u,
		loading: f,
		disabled: h,
		fullWidth: v,
		...b,
		children: [
			f && /* @__PURE__ */ s(m, {}),
			C && S(g),
			/* @__PURE__ */ s(p, { children: i }),
			w && S(_)
		]
	});
});
h.displayName = "Button";
var g = o.forwardRef((n, r) => {
	let { icon: a, className: o, variant: c = "solid", size: l = "sm", colorScheme: u = "default", loading: p = !1, iconVariant: h = "default", "aria-label": g, ..._ } = n;
	return /* @__PURE__ */ s(d, {
		ref: r,
		variant: c,
		size: l,
		colorScheme: u,
		loading: p,
		className: t(h === "cell" ? "h-6 w-6 p-1" : i[l], o),
		"aria-label": g,
		..._,
		children: p ? /* @__PURE__ */ s(m, {}) : h === "cell" ? /* @__PURE__ */ s("span", {
			className: t("inline-flex items-center justify-center shrink-0"),
			children: /* @__PURE__ */ s(e, {
				name: a,
				color: "inherit",
				className: "w-3.5 h-3.5"
			})
		}) : /* @__PURE__ */ s(f, { name: a })
	});
});
g.displayName = "Button.IconButton";
var _ = Object.assign(h, {
	Root: d,
	Icon: f,
	Text: p,
	Loader: m,
	IconButton: g
});
export { _ as Button, _ as default, g as IconButton };

//# sourceMappingURL=index.js.map